import { render, staticRenderFns } from "./DesktopTopPart.vue?vue&type=template&id=db4597e4"
import script from "./DesktopTopPart.vue?vue&type=script&lang=js"
export * from "./DesktopTopPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports